// this file added by Bearer Web Developer
import React from "react";
interface IAccessingFeatureMenuContext {
    setAccessingFeatureMenuElement: React.Dispatch<React.SetStateAction<HTMLElement | null>>
    accessingFeatureMenuElement: HTMLElement | null
}
export const AccessingFeatureMenuContext = React.createContext<IAccessingFeatureMenuContext>({ 
    setAccessingFeatureMenuElement: () => {},
    accessingFeatureMenuElement: null
});